export const SETTINGS = {
    PREFERRED_APPS: [
        'ful',
        'tnc',
        'tracker',
        'devcen',
        'webxd',
    ],
    LOCALIZATION_OPTIONS: {
        languages: {
            'en-US': 'English',
            'fr-FR': 'French',
            'fr-CA': 'French (Canada)',
            'zh-CN': 'Chinese (Simplified)',
            'zh-TW': 'Chinese (Traditional)',
            'es-ES': 'Spanish'
        },
        locales: {
            'zh-CN': 'Chinese (Simplified)',
            'zh-TW': 'Chinese (Traditional)',
            'en-AU': 'English (Australia)',
            'en-CA': 'English (Canada)',
            'en-HK': 'English (Hong Kong)',
            'en-IE': 'English (Ireland)',
            'en-IN': 'English (India)',
            'en-PH': 'English (Philipines)',
            'en-GB': 'English (United Kingdom)',
            'en-US': 'English (US 12 hour)',
            'en-US24': 'English (US 24 hour)',
            'en-SG': 'English (Singapore)',
            'fr-FR': 'French',
            'fr-CA': 'French (Canada)',
            'es-ES': 'Spanish',
        },
        localized: {
            languages: {
                'zh-CN': '简体字',
                'zh-TW': '繁體字',
                'en-US': 'English',
                'fr-FR': 'Français',
                'fr-CA': 'Français Canadien',
                'es-ES': 'Español',
            },
            locales: {
                'zh-CN': '简体字',
                'zh-TW': '繁體字',
                'en-AU': 'English (Australia)',
                'en-CA': 'English (Canada)',
                'en-HK': 'English (Hong Kong)',
                'en-IE': 'English (Ireland)',
                'en-IN': 'English (India)',
                'en-PH': 'English (Philipines)',
                'en-GB': 'English (United Kingdom)',
                'en-US': 'English (US 12 hour)',
                'en-US24': 'English (US 24 hour)',
                'en-SG': 'English (Singapore)',
                'fr-FR': 'Français',
                'fr-CA': 'Français Canadien',
                'es-ES': 'Español',
            }
        }
    },
    REGION_MAPS: {
        contactData: {
            us: {
                phone: '612-249-0431',
                tollFree: '866-245-8100'
            },
            china: {
                phone: '+86 4006-233-251'
            },
            australia: {
                phone: '1300 532 383'
            }
        },
        notificationKeys: {
            'suspension-warning': 'cp.subscription.warning',
            'suspended': 'cp.subscription.suspended',
            'seasonal-hold': 'cp.subscription.seasonalHold'
        },
        timezones: {
            chinese: [
                'Asia/Chongqing',
                'Asia/Chungkiung',
                'Asia/Hong_Kong',
                'Asia/Kashgar',
                'Asia/Macao',
                'Asia/Macau',
                'Asia/Harbin',
                'Asia/Shanghai',
                'Asia/Taipei',
                'Asia/Urumqi',
                'Hongkong',
                'PRC'
            ],
            australian: [
                'Etc/GMT+4',
                'Etc/GMT+5',
                'Etc/GMT+6',
                'Etc/GMT+7',
                'Etc/GMT+8',
                'Etc/GMT+9',
                'Etc/GMT+10',
                'Etc/GMT+11',
                'Etc/GMT+12',
                'Japan',
                'NZ',
                'NZ-CHAT',
                'ROK',
                'Singapore'
            ],
            exceptions: {
                pacific: [
                    'Easter',
                    'Galapagos',
                    'Gambier',
                    'Honolulu',
                    'Johnston',
                    'Marquesas',
                    'Midway',
                    'Niue',
                    'Pago_Pago',
                    'Pitcairn',
                    'Rarotonga',
                    'Tahiti'
                ],
                asia: [
                    'Aden',
                    'Amman',
                    'Baghdad',
                    'Bahrain',
                    'Beirut',
                    'Damascus',
                    'Gaza',
                    'Hebron',
                    'Istanbul',
                    'Jerusalem',
                    'Kuwait',
                    'Nicosia',
                    'Qatar',
                    'Riyadh',
                    'Tehran',
                    'Tel_Aviv'
                ]
            }
        }
    }
};



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./public/app/settings.ts